import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import config from "lib/fr-config";
import { sleep } from "lib/commonUtil";

const UNIT_LENGTH = config.itemList.LENGTH;
const EXP_MINUTE = 30;
const WAIT_MILLISEC = config.storeModule.waitForLoadingMilliSec;

const SET_NOW_CATEGORY = "myItem/SET_NOW_CATEGORY";
const SET_EXPIRATION_DATE = "myItem/SET_EXPIRATION_DATE";
const INIT_EXPORTED_DATA = "myItem/INIT_EXPORTED_DATA";
const CONCAT_ITEM_LIST = "myItem/CONCAT_ITEM_LIST";
const SET_IS_END = "myItem/SET_IS_END";
const INIT_ITEM_LIST_DATA = "myItem/INIT_ITEM_LIST_DATA";
const EXPORT_ITEM_LIST = "myItem/EXPORT_ITEM_LIST";
const INIT_CAT_LIST_OF_MINE = "myItem/INIT_CAT_LIST_OF_MINE";
const SET_CAT_LIST_OF_MINE = "myItem/SET_CAT_LIST_OF_MINE";
const SET_IS_LOADING = "myItem/SET_IS_LOADING";
const SET_NEED_REALTIME_DATA = "myItem/SET_NEED_REALTIME_DATA";
const UPDATE_NICKNAME_FROM_EXPORT_LIST =
  "myItem/UPDATE_NICKNAME_FROM_EXPORT_LIST";
const UPDATE_NICKNAME_FROM_DATA = "myItem/UPDATE_NICKNAME_FROM_DATA";
const INIT_LIST_BY_CATEGORY = "myItem/INIT_LIST_BY_CATEGORY";
const INIT_ALL_DATA = "myItem/INIT_ALL_DATA";

const setNowCategory = createAction(SET_NOW_CATEGORY);
const setExpirationDate = createAction(SET_EXPIRATION_DATE);
const initExportedData = createAction(INIT_EXPORTED_DATA);
const concatItemList = createAction(CONCAT_ITEM_LIST);
const setIsEnd = createAction(SET_IS_END);
const initItemListData = createAction(INIT_ITEM_LIST_DATA);
const exportItemList = createAction(EXPORT_ITEM_LIST);
const initCatListOfMine = createAction(INIT_CAT_LIST_OF_MINE);
const setCatListOfMine = createAction(SET_CAT_LIST_OF_MINE);
const setIsLoading = createAction(SET_IS_LOADING);
const setNeedRealtimeData = createAction(SET_NEED_REALTIME_DATA);
const updateNicknameFromExportList = createAction(
  UPDATE_NICKNAME_FROM_EXPORT_LIST
);
const updateNicknameFromData = createAction(UPDATE_NICKNAME_FROM_DATA);
const initListByCategory = createAction(INIT_LIST_BY_CATEGORY);
const initAllData = createAction(INIT_ALL_DATA);

const getItemState = ({ getState }) => {
  const itemState = getState().myItem.toJS();
  return itemState;
};

const getNowCategory = ({ getState }) => {
  const itemState = getItemState({ getState });
  const { nowCategory } = itemState;
  return nowCategory;
};

const getIsLoading = ({ getState }) => {
  const itemState = getItemState({ getState });
  const { isLoading } = itemState;
  return isLoading;
};

const getTargetData = ({ getState, category }) => {
  const itemState = getItemState({ getState });
  const targetData = itemState.listByCategory[category];
  return targetData;
};

const getLastHash = list => {
  if (list.length === 0) return undefined;
  const length = list.length;
  return list[length - 1]["itemHash"];
};

const getListWithUpdatedNicknameByName = (inputArray, itemHash, nickname) => {
  return inputArray.map(unit => {
    if (unit.itemHash === itemHash) {
      return { ...unit, nickname };
    }
    return unit;
  });
};

const getDataObjWithUpdatedNicknameByName = (inputObj, itemHash, nickname) => {
  const returnObj = {};

  for (const category in inputObj) {
    if (inputObj.hasOwnProperty(category)) {
      const newItemList = getListWithUpdatedNicknameByName(
        inputObj[category].savedList,
        itemHash,
        nickname
      );
      returnObj[category] = inputObj[category];
      returnObj[category].savedList = newItemList;
    }
  }

  return returnObj;
};

const updateCategoryListOfMine = async ({
  needRealtimeData,
  dispatch,
  idToken
}) => {
  dispatch(setCatListOfMine(["all"]));
  const { code, res, errInfo } = await Restful.getCategoryOfMyItemAPI({
    needRealtimeData,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }
  dispatch(setCatListOfMine(["all"].concat(res.list)));
};

const requestItemList = async ({
  category,
  savedList,
  needRealtimeData,
  idToken
}) => {
  const length = UNIT_LENGTH;
  let backendFunc;
  switch (category) {
    case "all":
      backendFunc = Restful.getMyWholeItemAPI;
      break;
    default:
      backendFunc = Restful.getMyItemByCategoryAPI;
      break;
  }
  const lastHash = getLastHash(savedList);
  const { code, res, errInfo } = await backendFunc({
    idToken,
    category: category === "all" ? undefined : category,
    lastHash,
    length,
    needRealtimeData
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    return { list: res.list };
  }
};

const checkExpDate = ({ getState }) => {
  const itemState = getItemState({ getState });
  const { expirationDate } = itemState;
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setExpDate = ({ dispatch }) => {
  const expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  dispatch(setExpirationDate(expirationDate));
};

const eraseExpiredData = ({ dispatch }) => {
  dispatch(initListByCategory());
  dispatch(initCatListOfMine());
  dispatch(initExportedData());
};

const addNewList = async ({
  category,
  needRealtimeData = false,
  dispatch,
  getState,
  idToken
}) => {
  const targetData = getTargetData({ getState, category });
  const { savedList } = targetData;
  const { list } = await requestItemList({
    category,
    savedList,
    needRealtimeData,
    idToken
  });
  dispatch(concatItemList({ category, list }));
  dispatch(setIsEnd({ category, length: list.length }));
};

const checkCatListOfMine = async ({
  needRealtimeData,
  getState,
  dispatch,
  idToken
}) => {
  const itemState = getItemState({ getState });
  const { catListOfMine } = itemState;
  if (!catListOfMine) {
    await updateCategoryListOfMine({ needRealtimeData, dispatch, idToken });
  }
};

const getFirstListAndCatList = async ({
  category,
  init = false,
  forceUpdate = false,
  dispatch,
  getState,
  idToken
}) => {
  let isLoading = getIsLoading({ getState });

  while (isLoading) {
    await sleep(WAIT_MILLISEC);
    isLoading = getIsLoading({ getState });
  }

  dispatch(setIsLoading(true));
  dispatch(setNowCategory(category));

  const { needUpdate } = checkExpDate({ getState });
  if (init && needUpdate) {
    eraseExpiredData({ dispatch });
  }

  const itemState = getItemState({ getState });
  const { needRealtimeData } = itemState;

  if (init) {
    /** 병렬 요청위해 await 제거 */
    checkCatListOfMine({ needRealtimeData, getState, dispatch, idToken });
  }

  const targetData = getTargetData({ getState, category });

  if (forceUpdate || !targetData) {
    dispatch(initExportedData());
    dispatch(initItemListData({ category }));
    try {
      await addNewList({
        category,
        needRealtimeData,
        dispatch,
        getState,
        idToken
      });
    } catch (error) {
      dispatch(setIsLoading(false));
      throw error;
    }
  }

  const nowCategory = getNowCategory({ getState });
  if (nowCategory === category) {
    dispatch(exportItemList(category));
  }

  if (init && needUpdate) setExpDate({ dispatch });

  if (needRealtimeData) {
    dispatch(setNeedRealtimeData(false));
  }

  dispatch(setIsLoading(false));
};

export const initItemList = idToken => async (dispatch, getState) => {
  let nowCategory = getNowCategory({ getState });
  if (!!nowCategory) return null;

  getFirstListAndCatList({
    category: "all",
    init: true,
    dispatch,
    getState,
    idToken
  });
};

export const changeItemList =
  ({ category, forceUpdate, idToken }) =>
  async (dispatch, getState) => {
    getFirstListAndCatList({
      category,
      forceUpdate,
      dispatch,
      getState,
      idToken
    });
  };

export const getList = idToken => async (dispatch, getState) => {
  const itemState = getItemState({ getState });
  const { isEnd } = itemState;
  const category = getNowCategory({ getState });
  const isLoading = getIsLoading({ getState });

  if (isLoading || isEnd) return null;

  dispatch(setIsLoading(true));

  try {
    await addNewList({ category, dispatch, getState, idToken });
  } catch (error) {
    dispatch(setIsLoading(false));
    throw error;
  }

  const nowCategory = getNowCategory({ getState });
  if (nowCategory === category) {
    dispatch(exportItemList(category));
  }

  dispatch(setIsLoading(false));
};

export const removeItem =
  ({ itemHash, idToken }) =>
  async (dispatch, getState) => {
    const { code, errInfo } = await Restful.removeMyItemAPI({
      idToken,
      itemHash
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }
    dispatch(initListByCategory());
    if (code === "UnknownItem") return code;
    else return null;
  };

export const uploadItem =
  ({ filename, itemInfo, idToken }) =>
  async (dispatch, getState) => {
    const { category, brand } = itemInfo;
    if (!category || !brand) {
      throw Error(`empty input => category:${category}, brand:${brand}`);
    }

    const { code, errInfo } = await Restful.setMyItemAPI({
      idToken,
      data: {
        file: filename,
        info: itemInfo
      }
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    } else if (code === "WrongInput") {
      const errObj = Error("input error");
      errObj.errorValue = { info: JSON.stringify(itemInfo), filename };
      throw errObj;
    }
  };
export const updateNicknameFromItem =
  ({ itemHash, nickname }) =>
  async (dispatch, getState) => {
    dispatch(updateNicknameFromExportList({ itemHash, nickname }));
    dispatch(updateNicknameFromData({ itemHash, nickname }));
  };

export const setRealtimeDataOnNextRequest = () => (dispatch, getState) => {
  dispatch(setNeedRealtimeData(true));
};

export const removeExportedList = () => async (dispatch, getState) => {
  dispatch(setNowCategory(null));
  dispatch(initExportedData());
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  itemList: [],
  expirationDate: null,
  nowCategory: null,
  isEnd: false,

  listByCategory: {},
  /*
  listByCategory 의 구조.
  listByCategory: {
    [category name]: {
      savedList: [],
      isEnd: false
    }
  },
  */
  isLoading: false,

  needRealtimeData: false,

  catListOfMine: null
});

export default handleActions(
  {
    [SET_NOW_CATEGORY]: (state, action) => {
      const category = action.payload;
      return state.set("nowCategory", fromJS(category));
    },
    [SET_EXPIRATION_DATE]: (state, action) => {
      const expirationDate = action.payload;
      return state.set("expirationDate", fromJS(expirationDate));
    },
    [INIT_EXPORTED_DATA]: (state, action) => {
      const { itemList, isEnd } = initialState.toJS();
      return state
        .set("itemList", fromJS(itemList))
        .set("isEnd", fromJS(isEnd));
    },
    [CONCAT_ITEM_LIST]: (state, action) => {
      const { category, list } = action.payload;
      const { listByCategory } = state.toJS();
      const { savedList } = listByCategory[category];
      return state.setIn(
        ["listByCategory", category, "savedList"],
        fromJS(savedList.concat(list))
      );
    },
    [SET_IS_END]: (state, action) => {
      const { category, length } = action.payload;
      const isEnd = length === UNIT_LENGTH ? false : true;
      return state.setIn(["listByCategory", category, "isEnd"], fromJS(isEnd));
    },
    [INIT_ITEM_LIST_DATA]: (state, action) => {
      const { category } = action.payload;
      const newData = { savedList: [], isEnd: false };
      return state.setIn(["listByCategory", category], fromJS(newData));
    },
    [EXPORT_ITEM_LIST]: (state, action) => {
      const category = action.payload;
      const { listByCategory } = state.toJS();
      const { savedList, isEnd } = listByCategory[category];
      return state
        .set("itemList", fromJS(savedList))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_CAT_LIST_OF_MINE]: (state, action) => {
      const { catListOfMine } = initialState.toJS();
      return state.set("catListOfMine", fromJS(catListOfMine));
    },
    [SET_CAT_LIST_OF_MINE]: (state, action) => {
      const catListOfMine = action.payload;
      return state.set("catListOfMine", fromJS(catListOfMine));
    },
    [SET_IS_LOADING]: (state, action) => {
      const inputBool = action.payload;
      return state.set("isLoading", fromJS(inputBool));
    },
    [SET_NEED_REALTIME_DATA]: (state, action) => {
      const needRealtimeData = action.payload;
      return state.set("needRealtimeData", fromJS(needRealtimeData));
    },
    [UPDATE_NICKNAME_FROM_EXPORT_LIST]: (state, action) => {
      const { itemHash, nickname } = action.payload;
      const { itemList } = state.toJS();
      const newItemList = getListWithUpdatedNicknameByName(
        itemList,
        itemHash,
        nickname
      );
      return state.set("itemList", fromJS(newItemList));
    },
    [UPDATE_NICKNAME_FROM_DATA]: (state, action) => {
      const { itemHash, nickname } = action.payload;
      const { listByCategory } = state.toJS();
      const newListByCategory = getDataObjWithUpdatedNicknameByName(
        listByCategory,
        itemHash,
        nickname
      );

      return state.set("listByCategory", fromJS(newListByCategory));
    },
    [INIT_LIST_BY_CATEGORY]: (state, action) => {
      const { listByCategory } = initialState.toJS();
      return state.set("listByCategory", fromJS(listByCategory));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
